// Pokémon GO weather boost mapping
// Each weather condition boosts specific types by 1.2x damage

const WEATHER_BOOSTS = {
  'Sunny / Clear': ['Fire', 'Grass', 'Ground'],
  'Rainy':         ['Water', 'Electric', 'Bug'],
  'Partly Cloudy': ['Normal', 'Rock'],
  'Cloudy':        ['Fairy', 'Fighting', 'Poison'],
  'Windy':         ['Dragon', 'Flying', 'Psychic'],
  'Snow':          ['Ice', 'Steel'],
  'Fog':           ['Dark', 'Ghost'],
};

export const WEATHER_OPTIONS = ['None', ...Object.keys(WEATHER_BOOSTS)];

const WEATHER_BOOST_MULT = 1.2;

/**
 * Get the weather boost multiplier for a move type under given weather.
 * @param {string} weather - Weather condition name, or 'None'
 * @param {string} moveType - The type of the move
 * @returns {number} 1.2 if boosted, 1.0 otherwise
 */
export function getWeatherBoost(weather, moveType) {
  if (!weather || weather === 'None') return 1.0;
  const boosted = WEATHER_BOOSTS[weather];
  if (!boosted) return 1.0;
  return boosted.includes(moveType) ? WEATHER_BOOST_MULT : 1.0;
}

export default WEATHER_BOOSTS;
